const WishlistChunk = () => {
  import(
    /* webpackPreload: true */ /* webpackChunkName: 'preload-wishlist' */ 'components/Wishlist/Wishlist'
  ).then(({ default: Wishlist }) => {
    const wishlist = new Wishlist();
    wishlist.initEnableWishlist();
    wishlist.initEventsClickToWishlist();
    wishlist.initPageWishlist();
  });
};

export default WishlistChunk;
